// extracted by mini-css-extract-plugin
module.exports = {"dataTableFormat":"styles_dataTableFormat__25m5J","formSpace":"styles_formSpace__3zPv4","actionButton":"styles_actionButton__3XAzM","actionIcon":"styles_actionIcon__3RXs-"};